export default "__VITE_ASSET__BSynhuQv__"